import { lazy } from "react";

const CityPage = lazy(() => import("../pages/city/page"));

export const CITY_ROUTE_BASE_PATH = "/appliance-repair-service-in";

export const ALLOWED_CITY_SLUGS = [
  "anaheim",
  "santa-ana",
  "irvine",
  "huntington-beach",
  "garden-grove",
  "orange",
  "fullerton",
  "costa-mesa",
  "mission-viejo",
  "westminster",
  "newport-beach",
  "buena-park",
  "lake-forest",
  "tustin",
  "yorba-linda",
  "fountain-valley",
  "laguna-beach",
  "brea",
  "cypress",
  "seal-beach",
  "stanton",
  "la-habra",
  "placentia",
  "aliso-viejo",
  "dana-point",
] as const;

export type CitySlug = (typeof ALLOWED_CITY_SLUGS)[number];

export const CITY_DISPLAY_NAMES: Record<CitySlug, string> = {
  "anaheim": "Anaheim",
  "santa-ana": "Santa Ana",
  "irvine": "Irvine",
  "huntington-beach": "Huntington Beach",
  "garden-grove": "Garden Grove",
  "orange": "Orange",
  "fullerton": "Fullerton",
  "costa-mesa": "Costa Mesa",
  "mission-viejo": "Mission Viejo",
  "westminster": "Westminster",
  "newport-beach": "Newport Beach",
  "buena-park": "Buena Park",
  "lake-forest": "Lake Forest",
  "tustin": "Tustin",
  "yorba-linda": "Yorba Linda",
  "fountain-valley": "Fountain Valley",
  "laguna-beach": "Laguna Beach",
  "brea": "Brea",
  "cypress": "Cypress",
  "seal-beach": "Seal Beach",
  "stanton": "Stanton",
  "la-habra": "La Habra",
  "placentia": "Placentia",
  "aliso-viejo": "Aliso Viejo",
  "dana-point": "Dana Point",
};

const isCitySlug = (value: string): value is CitySlug => {
  return ALLOWED_CITY_SLUGS.includes(value as CitySlug);
};

export const loadCityPage = (slug: string) => {
  if (!isCitySlug(slug)) {
    return lazy(() => import("../pages/NotFound"));
  }

  return CityPage;
};
